<template>
  <main>
    <v-tabs show-arrows v-model="activeTab">
      <v-tabs-slider></v-tabs-slider>

      <v-tab href="#tab-1">Preferences</v-tab>
      <v-tab href="#tab-2">Profile</v-tab>
      <v-tab href="#tab-3">Change Email</v-tab>
      <v-tab href="#tab-4"  v-if="showPassword === true">Password</v-tab>
      <v-tab href="#tab-5" >Membership &amp; Loyalty</v-tab>

      <v-tab-item :value="'tab-1'" :key="1">
        <UserProfileContactPrefs />
      </v-tab-item>

      <v-tab-item :value="'tab-2'" ref="ticketTab" :key="2">
        <UserProfileImage />
        <UserProfileFull />
      </v-tab-item>

      <v-tab-item  v-if="showPassword === true" :value="'tab-3'" :key="3">
        <UserProfileChangeEmail />
      </v-tab-item>

      <v-tab-item  v-if="showPassword === true" :value="'tab-4'" :key="4">
        <UserProfilePassword />
      </v-tab-item>
      
      

      <v-tab-item :value="'tab-5'" :key="5">
        <UserProfileMembership />
        <UserProfileClientRefNo />
      </v-tab-item>
    </v-tabs>

    <FooterShout v-if="appLogin === false" :type="'help'"/>
  </main>
</template>

<script>
  import UserProfileFull from '@/components/UserProfileFull'
  import UserProfilePassword from '@/components/UserProfilePassword'
  import UserProfileChangeEmail from '@/components/UserProfileChangeEmail'
  import UserProfileClientRefNo from '@/components/UserProfileClientRefNo'
  import UserProfileImage from '@/components/UserProfileImage'
  import UserProfileContactPrefs from '@/components/UserProfileContactPrefs'
  import UserProfileMembership from '@/components/UserProfileMembership'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      UserProfileFull,
      UserProfileChangeEmail,
      UserProfilePassword,
      UserProfileClientRefNo,
      UserProfileImage,
      UserProfileContactPrefs,
      UserProfileMembership,
      FooterShout
    },
    data () {
      return {
        showPassword: false,
        showMembership: false,
        appLogin: false,
        activeTab: "tab-1",
      }
    },
    mounted () {
        console.log('User Profile component loaded')
        
        if(localStorage.appLogin === 'true'){
          this.appLogin = true
        }

        // Force the profile tab to be active if redirected from ticket platform
        if(typeof localStorage.returnUrl != 'undefined'){
          if(localStorage.returnUrl.includes('ticket')){
            this.activeTab = "tab-2"
          }
        }

        if(this.$getAuthenticatedUser() == null){
          console.log('User is not logged in')
          this.$router.push("/");
        } else {
          // check to see if the user was created with traditional registration (and not Facebook or Google)
          this.$getCurrentUserAttributes().subscribe((userData) => {
            if(userData.email_verified){
              console.log('user allowed to change password')
              this.showPassword = true //if they did register with their email, then let them change password
            } 
          })
        }
        console.log(this.$root.$data.referrer)
    },
  }
</script>
